import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface AdminAuthState {
  token: string | null;
  idConfiguracaoSelecionada: number | null;
}

const CHAVE_TOKEN = 'cardapio-sischef:admin:token';
const CHAVE_CONFIG = 'cardapio-sischef:admin:config';

function carregar(): AdminAuthState {
  if (typeof localStorage === 'undefined') {
    return { token: null, idConfiguracaoSelecionada: null };
  }
  try {
    return {
      token: localStorage.getItem(CHAVE_TOKEN),
      idConfiguracaoSelecionada: Number(localStorage.getItem(CHAVE_CONFIG)) || null,
    };
  } catch {
    return { token: null, idConfiguracaoSelecionada: null };
  }
}

const adminAuthSlice = createSlice({
  name: 'adminAuth',
  initialState: carregar(),
  reducers: {
    definirAdminToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
      localStorage.setItem(CHAVE_TOKEN, action.payload);
    },
    limparAdminToken(state) {
      state.token = null;
      state.idConfiguracaoSelecionada = null;
      localStorage.removeItem(CHAVE_TOKEN);
      localStorage.removeItem(CHAVE_CONFIG);
    },
    selecionarConfiguracao(state, action: PayloadAction<number | null>) {
      state.idConfiguracaoSelecionada = action.payload;
      if (action.payload == null) {
        localStorage.removeItem(CHAVE_CONFIG);
      } else {
        localStorage.setItem(CHAVE_CONFIG, String(action.payload));
      }
    },
  },
});

export const { definirAdminToken, limparAdminToken, selecionarConfiguracao } = adminAuthSlice.actions;
export const adminAuthReducer = adminAuthSlice.reducer;
